// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useMemo, useState } from "react";
import { Button, Stack, Switch, useMediaQuery, useTheme } from "@mui/material";
import {
  GridColDef,
  GridActionsCellItem,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import { Loading, StatusBar } from "../../atoms";
import {
  DeleteMerchantRequest,
  IMerchant,
  IVPosRouting,
  useAuthorization,
  useDeleteVPosRouting,
  useGetMemberVPosList,
  useGetVPosRoutingList,
  useMemberVPosDelete,
  useMemberVPosUpdate,
} from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { PagingResponse } from "../../../hooks/_types";
import { downloadExcel } from "../../../util/downloadExcel";
import SearchTable from "../../../components/atoms/SearchTable";
import { useUserInfo } from "../../../store/User.state";
import dayjs from "dayjs";

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBar status={value} />}</>;
}

type BankListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: any }) => void;
};
export const BankListingActiveTable = ({
  onRowClick,
}: BankListingTableProps) => {


  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [userInfo] = useUserInfo();
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
    searchText: null,
  });


  const {
    mutate: getMemberVPosList,
    isLoading,
  } = useGetMemberVPosList();
  const { mutate: memberVPosUpdate } = useMemberVPosUpdate();
  const { mutate: memberVPosDelete, isLoading: isDeleteLoading } =
    useMemberVPosDelete();
  const setSnackbar = useSetSnackBar();


  const editRow = React.useCallback(
    (memberVPos: IMemberVPos) => () => {
      navigate("/vpos-management/vpos-bankdefinition", { state: memberVPos });
    },
    [navigate]
  );


  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);



  const deleteRow = React.useCallback(
    (memberVPos: IMemberVPos) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(memberVPos.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  useEffect(() => {
    const savedFilter = localStorage.getItem("bankListActiveTabFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);


  useEffect(() => {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: "ACTIVE",
      ...getQueryParams(queryOptions),
    };
    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getMemberVPosList(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setTableData(data?.data);
        } else {
          setTableData(data?.data);
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
    setShouldRefresh(false);
  }, [
    getMemberVPosList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh
  ]);

  // , queryOptions

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);
    getMemberVPosList(
      {
        size: paginationModel.pageSize,
        page: paginationModel.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: "ACTIVE",
      },
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };


  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMemberVPosRequest = { id: selectedRowId };

    memberVPosDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          getMemberVPosList({
            size: paginationModel.pageSize,
            page: paginationModel.page <= 0 ? 0 : paginationModel.page,
            orderBy: "CreateDate",
            orderByDesc: true,
            status: "ACTIVE",
          }, 
          {
            onSuccess: (data) => {
              if (data.isSuccess) {
                setTableData(data?.data);
              } else {
                setTableData(data?.data);
                setSnackbar({
                  severity: "error",
                  description: data.message,
                  isOpen: true,
                });
              }
            },
            onError: () => {
              setSnackbar({
                severity: "error",
                description: "İşlem sırasında bir hata oluştu",
                isOpen: true,
              });
            },
          });
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          return [
            !!showUpdate ? <GridActionsCellItem
              label="Düzenle"
              onClick={editRow(params.row)}
              showInMenu
            /> : <></>,
            !!showDelete ? <GridActionsCellItem
              label="Sil"
              onClick={deleteRow(params.row)}
              showInMenu
            /> : <></>,
          ];
        },
      },
      { field: "bankName", headerName: "Banka Adı", width: 400 },
      {
        field: "mcc",
        headerName: "Mcc",
        width: 120
      },
      {
        field: "createDate",
        headerName: "Oluşturma Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "createUserName", headerName: "Oluşturan Kullanıcı", width: 200 },
      {
        field: "updateDate",
        headerName: "Son Güncellenme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        },
      },
      { field: "updateUserName", headerName: "Son Güncelleyen Kullanıcı", width: 200 },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Durum",
        width: 150,
        filterable: false
      },
      {
        headerName: "Varsayılan",
        field: "actions",
        type: "actions",
        width: 120,
        getActions: (params) => {
          if (params.row.mcc) {
            return [<></>];
          }
          const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const val = event.target.checked;
            memberVPosUpdate(
              {
                id: params.row.id,
                memberId: params.row.memberId,
                bankCode: params.row.bankCode,
                defaultBank: val,
                status: "ACTIVE",
              },
              {
                onSuccess: () => {
                  setShouldRefresh(true);
                },
              }
            );
          };
          return [<Switch checked={params.row.defaultBank} onChange={handleChange} />];
        },
      }
    ];
  }, [deleteRow, editRow, getMemberVPosList, memberVPosUpdate, paginationModel.page, paginationModel.pageSize, showDelete, showUpdate]);


  const onSave = () => {

    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: "ACTIVE",
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }
    getMemberVPosList(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                return {
                  "Banka Adı": item?.bankName,
                  "Oluşturma Tarihi": item?.createDate,
                  "Oluşturan Kullanıcı": item?.createUserName,
                  "Son Güncellenme Tarihi": item?.updateDate,
                  "Son Güncelleyen Kullanıcı": item?.updateUserName,
                  "Durum": item?.status,
                  "Varsayılan Banka": item?.defaultBank
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData || [], "Aktif Banka Listesi");
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };


  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };
  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem("bankListActiveTabFilter");
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem('bankListActiveTabFilter', JSON.stringify(queryParams))
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);

  // Komponent içerisinde
  const previousQueryParams = React.useRef({});
  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  const hasLoading = isLoading || isDeleteLoading;

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>

        <>
          <Table
            filterKey="bankListActiveTabFilter"
            columnVisibilityConfigKey="bankListActiveTabColumnVisibilityKey"
            hasActiveFilters={hasActiveFilters}
            handleFilterChange={handleFilterChange}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.totalItems || 0}
            onRowClick={onRowClick}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            isRowSelectable={() => false}
            rows={
              tableData?.result
                ? tableData.result.filter((item) => item.status === "ACTIVE")
                : []  // Provide an empty array as fallback
            }
            columns={columns}
            exportFileName="Sanal Pos Banka Listesi"
            onSave={() => onSave()}
          />
          <DeleteConfirmModal
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            onConfirm={() => handleDeleteConfirm()}
          ></DeleteConfirmModal>
        </>

      </Stack>
    </>
  );
};
